module.exports = __webpack_public_path__ + "img/invoice-de-female-sn.3666df60.png";